export const environment = {
  production: false,
  env: 'Staging',
  storageEncryptionKey: 'staging-key-change-in-production'
};
